import React from "react";

import SideMenuOutline from "./SideMenuOutline";

export default function SideMenu({ isSkeleton = false, isInventory, ...props }) {
  return <SideMenuOutline isOpen />;
}
